export class Log{
    /**
     * Write log in browser console. Use this function for enable and disable log write from parameter
     */
    public static writeLogDebug(message :any) :void {
        console.log(message);
    }
}